import { render } from "./DeliveryVehiculesActionMenu.vue?vue&type=template&id=a782046a&scoped=true"
import script from "./DeliveryVehiculesActionMenu.vue?vue&type=script&lang=js"
export * from "./DeliveryVehiculesActionMenu.vue?vue&type=script&lang=js"

import "./DeliveryVehiculesActionMenu.vue?vue&type=style&index=0&id=a782046a&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a782046a"]])

export default __exports__